import { motion } from "framer-motion";
import Indigie from "../Indigie.png"
import Salish from "../Salish.png"
import Lumminade from "../Lumminade.png"
import HoneyNettle from '../HoneyNettle.png'
import Forest from '../Forest.png'
import Sweetgrass from '../Sweetgrass.png'
import whitesage from '../whitesage.png'
import Cranberry from '../Cranberry1.png'
import Skokola from '../Skokola.png'

export default function Sodas() {
  return (
    <div className="bg-[#1d1d1d] text-white">
      <section className="relative w-full py-32 px-6 md:px-12 lg:px-20 text-center">
        
        <div className="relative w-full flex flex-col justify-center items-center text-white pb-12">
          <motion.div 
            className="relative text-lg md:text-xl font-semibold text-red tracking-wide mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="mt-28">Introducing our</p>
          </motion.div>
          <h1
            id="rust" 
            className="relative text-6xl md:text-6xl font-medium"
          >
            Soda Syrups
          </h1>
          <p className="relative text-lg md:text-xl text-gray-600 max-w-3xl mt-4">
          Great for mocktails, cocktails, sodas, teas, marinades, dressings & desserts.  We invite you to mix Natoncks Metsu handmade syrups into your own specialty cocktail creation, or mix with your favorite sparkling water.<br></br><br></br>

          These indigenous crafted syrups (and many more) have been featured in the form of handmade sodas at exclusive events and Pow-Wows in the PNW for years and are now available beyond the borders of Indigenous Country for your customers to Enjoy!
          </p>
        </div>

        <div class="bg-beige max-w-md justify-center mx-auto p-4 rounded-lg">
          <h2 class="text-black">To place an order for syrups please email <span class="font-bold text-red">info@natoncksmetsu.com</span> or text <span class="font-bold text-red">206.939.7055</span></h2>
          <div className="mt-4 max-w-sm mx-auto text-black">
              <p className="text-xl font-semibold text-black text-center mb-3">
                Available Sizes
              </p>

              <div className="divide-y divide-red">
                {[
                  { size: "4 oz", price: "$5" },
                  { size: "8 oz", price: "$10" },
                  { size: "32 oz", price: "$40" },
                  { size: "1/2 gallon", price: "$60" },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-3 text-base"
                  >
                    <span>{item.size}</span>
                    <span className="font-medium">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
        </div>



        <div className="max-w-6xl mx-auto pt-12">
          <h2  className="text-3xl md:text-4xl font-semibold text-center mb-6">Featured Syrups</h2>
          
          <div className="flex flex-wrap justify-center lg:px-0 md:px-2 px-8 sm:px-10 gap-8">
            
            <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Indigie} alt="Indigie Koolaid" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Indigie Koolaid</h3>
              <p className="text-gray-700 mt-2">Dried Hibiscus Flowers steeped in fresh pressed lime juice simple syrup</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: dried hibiscus flowers, fresh pressed lime juice, sugar</p>
            </div>

            <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Salish} alt="Salish Style" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Salish Style</h3>
              <p className="text-gray-700 mt-2">Hand harvested coast salish wild young cedar tips steeped in fresh pressed tangerine juice simple syrup.</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: fresh pressed tangerine juice, sugar, young fresh cedar tips</p>
            </div>

            <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Lumminade} alt="Lumminade" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Lumminade</h3>
              <p className="text-gray-700 mt-2">Fresh Mint & Rosemary steeped in fresh pressed lemon juice simple syrup. Named Lumminade from its initial service at the 2019 paddle to Lummi.</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: fresh pressed lemon juice, sugar, rosemary, mint
              </p>
            </div>

                     <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={HoneyNettle} alt="Honey Nettle" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Honey Nettle</h3>
              <p className="text-gray-700 mt-2">Rich Nettle Nectar sweetened with honey and a brightened with a splash of fresh lemon juice.</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: sugar, nettle nectar, honey, fresh pressed lemon juice
              </p>
            </div>


                     <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Forest} alt="Enchanted Forest" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Enchanted Forest</h3>
              <p className="text-gray-700 mt-2">Bright Tangy Lime, sweetened, and perfumed with cedar essence.</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: cedar, fresh pressed lime, juice, sugar
              </p>
            </div>

              <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Sweetgrass} alt="Sweetgrass Blackberry Sipper" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Sweetgrass Blackberry Sipper</h3>
              <p className="text-gray-700 mt-2">Fresh Hand Harvested Sweetgrass and tart sweet blackberries steeped in apple cider.</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: apple cider, cane sugar, fresh blackberries, hand harvest fresh sweetgrass 
              </p>
            </div>


            <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Cranberry} alt="Sweetgrass Apple Cranberry" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Sweetgrass Apple Cranberry</h3>
              <p className="text-gray-700 mt-2">Fresh hand harvested sweet grass blended with fresh pressed cider and tart cranberries, delicious as a soda or hot as a tea!</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: sweetgrass, cane sugar, cranberry juice</p>
            </div>

              <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Skokola} alt="Skokola" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Skokola</h3>
              <p className="text-gray-700 mt-2">Hand harvested Wild Ginger from Skokomish territory, steeped in fresh lemon juice and cane sugar</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: cane sugar, fresh pressed lemon juice, hand harvested wild ginger root from the Skokomish Reservation</p>
            </div>
          

         
              <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={whitesage} alt="White Sage Lavender" className="w-full h h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">White Sage Lavender</h3>
              <p className="text-gray-700 mt-2">Aromatic White Sage & Lavender over sweet rich apple cider</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: apple cider, cane sugar, white sage, lavender  
              </p>
            </div>

          </div>
        </div>

          <h2 className="text-3xl font-bold mt-16">Now Available for Wholesale</h2>
        
          <p className="mx-auto relative text-lg md:text-xl text-gray-600 max-w-3xl mt-4">
          NATONCKS Metsu is proud to offer our handcrafted syrups, made fresh in South Seattle using traditional Indigenous plant medicines and fresh fruit juices. These syrups are perfect for enhancing your beverage menu or offering directly to customers who want to create their own cocktails and handmade sodas. <br></br><br></br>
          Ideal for retailers, specialty grocery stores, restaurants, coffee shops, food trucks, and small grocers, our syrups bring unique, high-quality flavors to any selection.<br></br><br></br>
          For more information, email us or fill out the form below.

          </p>
   
      
<div className="w-full max-w-full overflow-hidden flex justify-center pt-8">

  <iframe
    src="https://docs.google.com/forms/d/e/1FAIpQLSeW3_9Tx0CPmtswxobzulRhrCOx8JDsx8jFnbqS5JYWhRS2Ww/viewform?embedded=true"
    className="w-full max-w-[640px]"
    height="1783"
  />          </div>

  


      </section>
    </div>
  );
}




/***
 * 
  <div className="bg-gray-100 p-6 rounded-lg shadow-lg text-center w-full md:w-[48%] lg:w-[30%]">
              <div className="w-full h-auto overflow-hidden rounded-md">
                <img src={Cranberry} alt="Sweetgrass Apple Cranberry" className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl font-semibold mt-4">Sweetgrass Apple Cranberry</h3>
              <p className="text-gray-700 mt-2">Fresh hand harvested sweet grass blended with fresh pressed cider and tart cranberries, delicious as a soda or hot as a tea!</p>
              <p className="text-gray-600 mt-1 italic text-sm">Ingredients: sweetgrass, cane sugar, cranberry juice</p>
            </div>
 */